import { z } from 'zod/v4';

import { FullInterpretationSchema, DrawnCardSchema } from './reading.schema';
import { SpreadSchema } from './spreads.schema';
import { ReadingModeSchema } from './tarot.schema';

export const LLMProviderIdSchema = z.enum([
  'hosted-mini',
  'external-api',
  'lm-studio-local',
  'symbolic-only',
]);

export const LLMTransportSchema = z.enum([
  'openai-compatible',
  'anthropic-compatible',
  'custom-json',
  'none',
]);

export const LLMContextSchema = z.enum(['web', 'local']);

export const LLMModelSchema = z.object({
  id: z.string().min(1),
  label: z.string().min(1),
  context_window: z.number().int().positive().nullable(),
  supports_streaming: z.boolean(),
  supports_json: z.boolean(),
});

export const ProviderCapabilitiesSchema = z.object({
  provider: LLMProviderIdSchema,
  transport: LLMTransportSchema,
  available: z.boolean(),
  local_only: z.boolean(),
  supports_streaming: z.boolean(),
  supports_json_mode: z.boolean(),
  supports_tools: z.boolean(),
  supports_system_prompt: z.boolean(),
});

export const LLMHealthSchema = z.object({
  connected: z.boolean(),
  latency_ms: z.number().int().nonnegative().nullable(),
  models: z.array(LLMModelSchema),
  error: z.string().min(1).nullable(),
});

export const LLMConfigSchema = z.object({
  provider: LLMProviderIdSchema,
  endpoint: z.string().min(1),
  api_key: z.string().min(1).nullable(),
  model: z.string().min(1),
  timeout_ms: z.number().int().positive(),
  max_retries: z.number().int().nonnegative(),
  enabled: z.boolean(),
});

export const LLMPayloadSchema = z.object({
  spread: SpreadSchema,
  question: z.string().min(1),
  intent: z.string().min(1).nullable(),
  cards: z.array(DrawnCardSchema),
  interpretation: FullInterpretationSchema,
  memory_context: z.string(),
  mode: ReadingModeSchema,
  max_tokens: z.number().int().positive(),
  temperature: z.number().min(0).max(2),
});

export const LLMResponseSchema = z.object({
  text: z.string().min(1),
  model: z.string().min(1),
  provider: LLMProviderIdSchema,
  tokens_in: z.number().int().nonnegative().nullable(),
  tokens_out: z.number().int().nonnegative().nullable(),
  finish_reason: z.string().min(1).nullable(),
});

export const LLMPayloadJsonSchema = z.toJSONSchema(LLMPayloadSchema);
